/**
 * Normalizes a RAD-E Payload, combining data and display_schema into a format
 * that is less fragmented and has data + display_schema as siblings.
 *
 * @example
 * // given
 * {
 *   org1: {
 *    data: { dataset1A: {...} }
 *    meta: { dataset1A: { display_schema: {...} }, parent_uri },
 *   },
 *   org2: {
 *    data: { dataset2A: {...} }
 *    meta: { dataset2A: { display_schema: {...} } },
 *   },
 * }
 * // returns
 * {
 *  org1: { dataset1A: { data, display_schema, parent_uri }}
 *  org2: { dataset2A: { data, display_schema }}
 * }
 *
 * @param {Object} payload - The RAD-E payload
 * @param {Object} payload.orgName<string, orgName>
 * @param {Object} payload.orgName.data
 * @param {Object} payload.orgName.meta
 * @param {Object} payload.orgName.data.<string, dataset>
 * @param {Object} payload.orgName.meta.<string, dataset>
 * @param {Object} payload.orgName.meta.<string, dataset>.display_schema
 */
export const normalizeRADE = payload => {
  const result = {};
  for (const orgName in payload) {
    const { data, meta } = payload[orgName] || {};

    if (!data || !meta) {
      result[orgName] = null;
      continue;
    }

    const normalized = {};
    for (const dataset in meta) {
      const { display_schema } = meta[dataset];
      normalized[dataset] = {
        display_schema,
        data: data[dataset],
        org: orgName,
      };
    }
    result[orgName] = normalized;
  }
  return result;
};

export const normalizeInlineRADE = (payload = {}) => {
  const radeData = normalizeRADE(payload);
  const normalized = [];
  for (const orgName in radeData) {
    for (const dataset in radeData[orgName]) {
      normalized.push(radeData[orgName][dataset]);
    }
  }
  return normalized;
};

export default normalizeRADE;
